module.exports = __webpack_public_path__ + "img/appIcon-ui--paymentsReminder.e131caf9.svg";